import * as React from "react";
import { getPathName } from "../../utils/utils";
const IngredientIcon = (props: any) => {
  const pathName = getPathName();
  const ingredientPath = "/ingredient";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill={
            pathName == ingredientPath
              ? "var(--menuBarIconActive)"
              : "var(--menuBarIconDeactive)"
          }
          d="M23.616 13.112a4.052 4.052 0 0 0-2.358-2.179c-1.11-.39-2.5-.267-3.717.33-.234.115-.48.187-.727.227a2.31 2.31 0 0 1 .335-1.557c.095-.152.198-.283.297-.392a.794.794 0 1 0-1.173-1.068 4.4 4.4 0 0 0-.423.548 3.89 3.89 0 0 0-.638 2.371 2.067 2.067 0 0 1-.35-.126 5.263 5.263 0 0 0-2.081-.555 5.743 5.743 0 0 1-.58-2.51 4.23 4.23 0 0 0-.855-2.562 4.3 4.3 0 0 0-2.166-1.52.785.785 0 0 0-.09-.021l-.037-.006c.263-.65.785-1.577 1.798-2.42.328-.27.407-.753.155-1.096A.793.793 0 0 0 9.862.433 7.95 7.95 0 0 0 8.34 2.096C7.96.692 6.16-.113 4.131.252c-1.435.257-3 1.687-3.806 2.516a1.152 1.152 0 0 0 .33 1.84c.904.43 2.5 1.085 3.843 1.084l.077-.001c-.578.727-.907 1.62-.907 2.51 0 1.34-.474 2.648-1.335 3.68a7.299 7.299 0 0 0-1.689 4.666c0 4.02 3.27 7.29 7.29 7.29 1.478 0 2.916-.45 4.124-1.278 1.395 1.385 2.658 1.421 3.551 1.134.214-.069.41-.18.59-.334.179.154.375.265.59.334.268.087.57.144.899.144 1.08 0 2.452-.616 3.884-2.836.986-1.527 1.726-3.362 2.174-4.632a4.356 4.356 0 0 0-.13-3.257ZM1.908 3.433c.968-.914 1.88-1.509 2.504-1.62 1.26-.227 2.31.203 2.407.738.042.233-.1.521-.39.79-.383.356-.97.625-1.61.74-.623.112-1.686-.128-2.91-.648Zm6.026 18.818a5.71 5.71 0 0 1-5.704-5.704 5.71 5.71 0 0 1 1.32-3.65A7.346 7.346 0 0 0 5.254 8.2c0-.706.358-1.427.956-1.927a2.942 2.942 0 0 1 1.733-.669.809.809 0 0 0 .203-.007h.002c.2 0 .406.018.615.053a2.665 2.665 0 0 1 1.853 2.55c0 .937.181 1.865.529 2.73l-.005.002a4.055 4.055 0 0 0-2.358 2.179 4.354 4.354 0 0 0-.13 3.257C9.1 17.639 9.84 19.474 10.826 21c.073.114.147.223.22.328a5.708 5.708 0 0 1-3.11.922Zm14.316-6.409c-1.215 3.449-3.16 6.925-4.977 6.341-.038-.012-.182-.134-.34-.52a.793.793 0 0 0-1.468 0c-.158.386-.303.508-.341.52-.765.246-1.553-.228-2.3-1.117a.81.81 0 0 0-.057-.08c-1.152-1.408-2.045-3.56-2.524-4.877l-.017-.048a105.106 105.106 0 0 0-.078-.219 2.776 2.776 0 0 1 .078-2.076c.09-.199.202-.382.333-.547a2.478 2.478 0 0 1 1.107-.79c.049-.017.1-.033.15-.047l.047-.011c.037-.01.074-.018.112-.026l.055-.01a2.6 2.6 0 0 1 .289-.036c.59-.042 1.245.09 1.831.384.429.215 1.163.417 1.986.434.02.002.041.003.063.003l.028-.002c.656.003 1.361-.112 2.012-.431.831-.408 1.787-.506 2.492-.258.64.226 1.152.7 1.44 1.337.294.649.322 1.386.079 2.076Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill={
              pathName == ingredientPath
                ? "var(--menuBarIconActive)"
                : "var(--menuBarIconDeactive)"
            }
            d="M0 0h24v24H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default IngredientIcon;
